<template>
  <div class="main-layout">
    <navbar />
    <div :class="containerClass">
      <child />
    </div>
  </div>
</template>
<script>
import Navbar from '~/components/Navbar'

export default {
  name: 'MainLayout',

  components: {
    Navbar
  },
  computed: {
    containerClass () {
      var mq = this.$mq
      var classArr = ['mt-2']
      if(mq == 'xl') classArr.push('container')
        else  classArr.push('container-fluid')
      if(mq == 'xs') classArr.push('px-1')
      return classArr
    }
  }
}

</script>
